export const initial = "initial";
export const pending = "pending";
export const loaded = "loaded";
export const error = "error";
